import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthProvider } from 'authorization/providers/auth/auth-provider';

/**
 * authentication guard preventing user from accessing page if logged in
 */
@Injectable()
export class UnauthGuard 
{
    /**
     * Class constructor
     * @param auth
     */
    constructor
        (
            private auth: AuthProvider
        )
    {
    }

    /**
    * CanActivate method implementation, returning true if the page can
    * be accessed or a URL tree if a redirection has to be done.
    * Will return always return true, but before doing so will check
    * whether there is a session and if so reset it.
    * This is to ensure that the application is free of any state before
    * entering the account-login page
    * @param next
    * @param state
    */
    async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    {
        // checks if user session exists
        let userIdentity = await this.auth.getUserIdentity();

        if (userIdentity)
        {
            await this.auth.signOut();
        }

        return true;
    }
}